module.exports = __webpack_public_path__ + "static/media/logo-southlake.d45cb842.svg";